import { Popover, PopoverContent, PopoverTrigger } from 'components/UI/popover'
import { ActivityV2 } from 'models/activityV2'
import CellEventFormatterV2 from './CellEventFormatterV2'

/**
 * Activity-table Event cell: the event prose renders on a single line (pills
 * flow inline; see the `[data-event-cell] [data-pill]` rule), truncating with an
 * ellipsis, and clicking opens a popover with the full content — mirroring the
 * click-to-expand treatment used by the Targets summary cells.
 *
 * Scoped to the Activity table only (the `data-event-cell` marker lives just on
 * this cell), so the event/activity history on company & deal detail pages is
 * unaffected.
 */
export function ActivityEventCell({ event }: { event: ActivityV2 }) {
  const content = CellEventFormatterV2({ event })

  return (
    <Popover>
      <PopoverTrigger asChild>
        <button
          type="button"
          data-event-cell
          onClick={(e) => e.stopPropagation()}
          className="block w-full min-w-0 max-w-full cursor-pointer truncate text-left"
        >
          {content}
        </button>
      </PopoverTrigger>
      <PopoverContent
        side="bottom"
        align="start"
        sideOffset={4}
        className="max-h-80 max-w-md overflow-y-auto !p-3"
      >
        <div
          data-event-cell-expanded
          className="whitespace-normal break-words text-sm leading-5"
        >
          {content}
        </div>
      </PopoverContent>
    </Popover>
  )
}
